import React from 'react'
import { Link } from 'react-router-dom'
import { Form, Input, Button, Checkbox } from 'antd'
import { view } from 'react-easy-state'

import FormIcon from 'components/common/FormIcon'

class RegisterForm extends React.Component {

  render() {
    const { submitting, form } = this.props
    const { getFieldDecorator } = form

    const labelLogin = submitting ? ' Registering...' : 'Register'

    return (<div className="auth-form">
      <Form onSubmit={(e) => this.props.onSubmit(e, this.props.form)} className="login-form form-card">
        <h2>Register</h2>
        <Form.Item>
          {getFieldDecorator('name', {
            rules: [{ required: true, message: 'Please enter name!' }],
          })(
            <Input
              prefix={<FormIcon type="user" />}
              placeholder="Name"
            />,
          )}
        </Form.Item>
        <Form.Item style={{ margin: 0 }}>
          {getFieldDecorator('phone', {
            rules: [{ required: false }],
          })(
            <Input
              prefix={<FormIcon type="phone" />}
              placeholder="Phone Number"
            />,
          )}
        </Form.Item>
        <Form.Item style={{ margin: 0, textAlign: 'right' }}>
          {getFieldDecorator('parents_phone', {
            rules: [{ required: false, message: null }],
          })(
            <Checkbox>Parent's phone</Checkbox>,
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('email', {
            rules: [{ required: true, message: 'Please enter email!' }],
          })(
            <Input
              prefix={<FormIcon type="mail" />}
              placeholder="Email"
            />,
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Please enter password!' }],
          })(
            <Input
              type="password"
              prefix={<FormIcon type="lock" />}
              placeholder="Password"
            />,
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('password_confirmation', {
            rules: [{ required: true, message: 'Please re-enter password!' }],
          })(
            <Input
              type="password"
              prefix={<FormIcon type="lock" />}
              placeholder="Confirm Password"
            />,
          )}
        </Form.Item>
        <div className="submit-button">
          <Button type="primary" htmlType="submit" className="login-button" loading={submitting}>
            {labelLogin}
          </Button>
        </div>
        <p className="switch-auth-link">Already have an account? <Link to="/login">Login</Link></p>
        {this.props.children}
      </Form>
    </div>)
  }
}

RegisterForm = Form.create({ name: 'login-form' })(view(RegisterForm))

export default RegisterForm
